import { type RefObject } from "react";
import { Icon } from "../Icon";
import { CaretMenu } from "./CaretMenu";
import { type SkillItem } from "./SlashMenu";

type Props = {
  textareaRef: RefObject<HTMLTextAreaElement | null>;
  value: string;
  slashStart: number;
  skills: readonly SkillItem[];
  selectedIndex: number;
  onSelect: (skill: SkillItem) => void;
};

export function SlashSkillMenu({
  textareaRef,
  value,
  slashStart,
  skills,
  selectedIndex,
  onSelect,
}: Props) {
  return (
    <CaretMenu
      textareaRef={textareaRef}
      value={value}
      slashStart={slashStart}
      items={skills.map((skill) => ({
        id: skill.id,
        disabled: skill.disabled,
        label: skill.name,
        icon: <Icon name="skills" size={12} />,
      }))}
      selectedIndex={selectedIndex}
      onSelect={(id) => {
        const skill = skills.find((s) => s.id === id);
        if (skill && !skill.disabled) onSelect(skill);
      }}
    />
  );
}
